/* eslint-disable indent */
/* eslint-disable react/react-in-jsx-scope */

import moment from "moment";

import { camelCase, commonSorterForTable, normalizeString } from "../../utils";
import { ReactComponent as Substract } from "../../assests/images/subtract.svg";
import { ReactComponent as Aubstract } from "../../assests/images/aubtract.svg";
import { ReactComponent as Audit_icon } from "../../assests/images/middleMile/audited-icon.svg";
import { ReactComponent as InfoIcon } from "../../assests/images/infoIcon.svg";
import { Row, Col, Tooltip } from "antd";
// const navigate = useNavigate();

const convertDate = (isoDate) => {
  return moment.utc(isoDate).format("DD-MM-YYYY HH:mm:ss");
};

export const bookingInfoCol = [
  {
    title: "Date & Time",
    dataIndex: "bookingDate",
    key: "bookingDate",
    sorter: (a, b) => commonSorterForTable(a, b, "bookingDate"),

    render: (text) => <span> {text ? convertDate(text) : "----"}</span>,
  },
  {
    title: "Booking CP / Sender Name",
    dataIndex: "bookingCpName",
    key: "bookingCpName",
    render: (text, rec) => (
      <Tooltip
        className="tooltipClass"
        placement="bottom"
        title={normalizeString(rec?.booking_cp_address)}
      >
        <span>{normalizeString(rec?.bookingCpName)} / {normalizeString(rec?.senderName)}</span>
      </Tooltip>
    ),
  },
  {
    title: "Recipient CP/ Receiver's Name",
    key: "destinationCpName",
    dataIndex: "destinationCpName",
    render: (text, rec) => (
      <Tooltip
        className="tooltipClass"
        placement="bottom"
        title={normalizeString(rec?.recipient_cp_address)}
      >
        <span>{normalizeString(rec?.destinationCpName)} / {normalizeString(rec?.receiverName)}</span>
      </Tooltip>
    ),
  },
  {
    title: "From Pincode",
    key: "fromPincode",
    dataIndex: "fromPincode",
    render: (text) => <span>{text ? text : "----"}</span>,
  },
  {
    title: "To Pincode",
    key: "receiverPincode",
    dataIndex: "receiverPincode",
    render: (text) => <span>{text ? text : "----"}</span>,
  },
  {
    title: "Booking / Service Type",
    key: "bookingServiceType",
    dataIndex: "bookingType",
    render: (text, rec) => {
      const booking = rec?.bookingType ? camelCase(rec.bookingType) : "";
      const service = rec?.serviceType ? camelCase(rec.serviceType) : "";
      const combined = [booking, service].filter(Boolean).join(" / ");
      return <span>{combined || "----"}</span>;
    },
  },
  {
    title: (
      <div>
        <div>Weight (kg)</div>
        <div>L * W * H (cm)</div>
      </div>
    ),
    key: "dimensions",
    render: (rec) => {
      const l = rec?.length;
      const w = rec?.width;
      const h = rec?.height;
      const wtRaw = rec?.weight;
      const hasDims = l !== undefined && l !== null && w !== undefined && w !== null && h !== undefined && h !== null;
      return (
        <div>
          <div>{wtRaw !== null ? wtRaw : "----"}</div>
          <div>{hasDims ? `${l} * ${w} * ${h}` : "----"}</div>
        </div>
      );
    },
  },
  {
    title: "Vol Weight (kg)",
    key: "volumetricWeight",
    dataIndex: "volumetricWeight",
    render: (text) => (
      <span>{text || text === 0 ? text : "----"}</span>
    ),
  },
  {
    title: "3PL Awb ",
    key: "tplAwbNumber",
    dataIndex: "tplAwbNumber",
    render: (text, rec) => (
      //if partercode was DELHIVERY then redirecthttps://www.delhivery.com/track-v2/package/37659810071816
      text !== null ?
        rec?.partnerCode === "DELHIVERY" ?
          <span style={{
            color: "#1890ff",
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: "bold"
          }} onClick={() => {
            window.open(`https://www.delhivery.com/track-v2/package/${text}`, "_blank");
          }}>
            {text ? text : "-"}
          </span> :
          <span style={{
            color: "#1890ff",
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: "bold"
          }} onClick={() => {
            window.open(`/shipment-tracker?awb=${text}`, "_blank");
          }}>
            {text ? text : "-"}
          </span>
        :
        <span>----</span>
    ),
  },
  {
    title: "Partner Name",
    key: "partnerCode",
    dataIndex: "partnerCode",
    render: (text) => <span>{text ? normalizeString(text) : "----"}</span>,
  },// {
  //   title: "Last Updated on",
  //   key: "updateTime",
  //   dataIndex: "updateTime",
  //   render: (text) => (
  //     <span>{text ? moment(text)?.format("DD-MM-YYYY HH:mm") : "----"}</span>
  //   ),
  // },
];
function loactionFun(rec) {
  if (rec.status === "IN_BAG_OUTSCAN_TO_CP") {
    return (
      <span>{`${normalizeString(rec?.status)} (${normalizeString(rec?.toPremisename)})`}</span>
    );
  }
  {
    return (
      <span>{`${rec?.status ? normalizeString(rec?.status) : "----"
        }`} {rec?.status == "OUT_SCAN_TO_CP" ? `(${normalizeString(rec.toPremisename)})` : ""}</span>
    );
  }
}

// Helper function for location only (without status)
function locationOnlyFun(rec) {
  if (rec.status === "SCHEDULED_FOR_TRIP" || rec.status === "HUB-OUTSCAN") {
    return (
      <span>{`${camelCase(rec?.premisename || rec?.premiseName)} to ${camelCase(
        rec?.topremisename || rec?.outscanDetails?.toPremiseName || rec?.toPremisename
      )}`}</span>
    );
  } else if (rec.status === "OUT_SCAN_TO_CP") {
    return (
      <span>
        {camelCase(rec?.premisename || rec?.premiseName)}
      </span>
    );
  } else if (rec.status === "INSCANNED_AT_CP") {
    return (
      <span>
        {camelCase(rec?.topremisename || rec?.toPremisename)}
      </span>
    );
  } else if (rec.status === "DELIVERED") {
    return (
      <span>
        {camelCase(rec?.topremisename || rec?.toPremisename)}
      </span>
    );
  } else if (rec.status === "RTO_DELIVERED") {
    return (
      <span>
        {camelCase(rec?.topremisename || rec?.toPremisename)}
      </span>
    );
  } else if (rec.status === "OUT_FOR_DELIVERY") {
    return (
      <span>
        {camelCase(rec?.topremisename || rec?.toPremisename)}
      </span>
    );
  } else if (rec.status === "RTO_OUT_FOR_DELIVERY") {
    return (
      <span>
        {camelCase(rec?.topremisename || rec?.toPremisename)}
      </span>
    );
  } else if (rec.status === "UNDELIVERED") {
    return (
      <span>
        {camelCase(rec?.topremisename || rec?.toPremisename)}
      </span>
    );
  } else if (rec.status === "RETURN_INITIATED" && rec.driverName !== null) {
    return (
      <span>
        {rec?.toPremisename == null ? "----" : camelCase(rec?.topremisename || rec?.toPremisename)}
      </span>
    );
  }
  else {
    return (
      <span>{camelCase(rec?.premisename || rec?.premiseName)}</span>
    );
  }
}

export const customisezColoum = [
  {
    title: "Date and Time",
    dataIndex: "date",
    render: (text) => <span>{text ? convertDate(text) : "----"}</span>,
    sorter: (a, b) => commonSorterForTable(a, b, "date"),
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (text) => <span>{text ? normalizeString(text) : "----"}</span>,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (text, rec) => (!rec.isException ? loactionFun(rec) : "----"),
  },
  {
    title: "Location",
    dataIndex: "premiseName",
    render: (text, rec) => (!rec.isException ? locationOnlyFun(rec) : "----"),
  },
  {
    title: "User",
    dataIndex: "user",
    width: 100,
    render: (text, rec) => {
      console.log("rec", rec);

      // Extract user name (remove @domain part)
      const atIndex = text ? text.indexOf("@") : -1;
      const userName = atIndex !== -1 ? text.substring(0, atIndex + 1) : text;

      // Get driver name from various possible field names
      const driverName = rec?.driverName;

      // Define statuses that should show driver name (case-insensitive)
      const driverStatuses = [
        "RTO_DELIVERED", "OUT_FOR_DELIVERY", "DELIVERED",
        "RTO_OUT_FOR_DELIVERY", "RETURN_INITIATED", "RETURN_REVOKED",
        "INSCANNED_AT_CP", "UNDELIVERED", "ATTEMPTED"
      ];

      const currentStatus = rec?.status?.toUpperCase();
      const shouldShowDriver = driverStatuses.includes(currentStatus) && driverName;

      // Determine what to display
      let displayText = "----";
      let tooltipText = "";

      if (shouldShowDriver) {
        displayText = driverName;
        tooltipText = `Driver: ${driverName}${userName ? ` | User: ${userName}` : ""}`;
      } else if (userName) {
        displayText = userName;
        tooltipText = `User: ${userName}${driverName ? ` | Driver: ${driverName}` : ""}`;
      }

      return (
        <Tooltip title={tooltipText}>
          <span>{displayText}</span>
        </Tooltip>
      );
    },
  },
  {
    title: "Exception",
    dataIndex: "exception",
    render: (text, rec) => (rec.isException ? loactionFun(rec) : "----"),

    // render: (text) => dateFun(text),
  },
  {
    title: "Remarks",
    // dataIndex: "remarks",
    render: (record) => {
      return record?.status === "Outscan" ||
        record?.status === "SCHEDULED_FOR_TRIP" || record?.status === "HUB-OUTSCAN" || record?.status === "IN-BAG-OUTSCAN" ? (
        <span>
          {(record?.status === "SCHEDULED_FOR_TRIP" ? "Scheduled Outscan" : "Outscan") + ` from ${normalizeString(
            record?.premisename || record?.premiseName
          )} to ${normalizeString(record?.topremisename || record?.toPremisename)} `}
          {record?.lcrNum && (
            <>
              <span style={{ fontWeight: "bold" }}>
                LCR No.:
                <span
                  style={{ color: "#2977ff", cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => {
                    const recordToStore = {
                      vehicle_lcr_id: record.lcrNum,
                    };
                    sessionStorage.setItem("LCR_REPORT_RECORD", JSON.stringify(recordToStore));
                    window.open(window.location.origin + "/lcr-report", "_blank");
                  }}
                >
                  {record?.lcrNum || "N/A"}
                </span>
              </span>
            </>
          )}
          <span className="tooltipClass">
            <Tooltip
              className="tooltipClass"
              placement="bottom"
              title={
                <div className="tooltipClass">
                  <div className="item">
                    <span className="label">Co-loader:</span>{" "}
                    <span className="value">{record?.coloader || record?.coLoader || "N/A"}</span>
                  </div>
                  <div className="item">
                    <span className="label">Transport Type:</span>{" "}
                    <span className="value">{record?.travelby || record?.travelBy || "N/A"}</span>
                  </div>
                  <div className="item">
                    <span className="label">Flight Number:</span>{" "}
                    <span className="value">{record?.flightnum || record?.flightNum || "N/A"}</span>
                  </div>
                  <div className="item">
                    <span className="label">Vehicle No:</span>{" "}
                    <span className="value">{record?.vehiclenum || record?.vehicleNum || "N/A"}</span>
                  </div>
                  <div className="item">
                    <span className="label">Driver Name:</span>{" "}
                    <span className="value">{record?.drivername || record?.driverName || "N/A"}</span>
                  </div>
                </div>
              }
            >
              <InfoIcon />
            </Tooltip>
          </span>
        </span>
      ) : record?.remarks ? (
        record?.status === "DELIVERED" || record?.status === "RTO_DELIVERED" ? (
          <span
            style={{
              textDecoration: "underline",
              cursor: "pointer",
              color: "#1890ff"
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log("Delivered remarks clicked:", record);

              // Extract URLs from remarks field
              const remarksText = record?.remarks || "";
              console.log("Remarks content:", remarksText);

              // Find URLs in remarks (supports comma-separated URLs)
              const urlRegex = /(https?:\/\/[^\s,]+)/g;
              const urls = remarksText.match(urlRegex) || [];

              console.log("Found URLs in remarks:", urls);

              if (urls.length > 0) {
                // Track click count for this record to cycle through URLs
                const clickKey = `click_${record?.awbNo || record?.awbNumber || record?.shipmentId}`;
                let clickCount = parseInt(sessionStorage.getItem(clickKey) || "0");

                // Get the URL to open (cycle through available URLs)
                const urlToOpen = urls[clickCount % urls.length];

                // Open the URL in new tab
                window.open(urlToOpen, "_blank");

                // Increment click count for next time
                sessionStorage.setItem(clickKey, (clickCount + 1).toString());

                console.log(`Opening URL ${clickCount + 1}/${urls.length}:`, urlToOpen);
              } else {
                console.log("No URLs found in remarks");
                alert("No URLs found in delivery remarks");
              }
            }}
            title="Click to view delivery details"
          >
            View
          </span>
        ) : (
          (() => {
            // Check if remarks contains URLs
            const remarksText = record?.remarks || "";
            const urlRegex = /(https?:\/\/[^\s,]+)/g;
            const urls = remarksText.match(urlRegex) || [];

            if (urls.length > 0) {
              return (
                <span
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: "#1890ff"
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // Open the first URL
                    window.open(urls[0], "_blank");
                  }}
                  title="Click to view remark link"
                >
                  View
                </span>
              );
            } else {
              return <span>{record?.remarks}</span>;
            }
          })()
        )
      ) : (
        <div>----</div>
      );
    },
  },
];


export const deliveryInfoCol = [
  {
    title: "Delivery Date",
    key: "action",
  },
  {
    title: "From Center",
    key: "action",
  },
  {
    title: "To Center",
    key: "action",
  },
  {
    title: "Receiver Name",
    key: "action",
  },
  {
    title: "Receiver Phone",
    key: "action",
  },
  {
    title: "Reason",
    key: "action",
  },
  {
    title: "Status",
    key: "action",
  },
  {
    title: "POD.",
    key: "action",
  },
  {
    title: "Signature",
    key: "action",
  },
  {
    title: "Remarks",
    key: "action",
  },
];

export const travelInfoColSecondPage = [
  {
    title: "Date and Time",
    dataIndex: "date",
    render: (text) => <span>{text ? convertDate(text) : "----"}</span>,
    sorter: (a, b) => commonSorterForTable(a, b, "date"),
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (text, rec) => <span>{text === "OUT_SCAN_TO_CP" ? normalizeString(text) + " (" + normalizeString(rec?.topremisename || rec?.toPremisename) + ")" : normalizeString(text) ?? "----"}</span>,
  },
  {
    title: "Location",
    dataIndex: "location",
    render: (text, rec) => (!rec.isException ? locationOnlyFun(rec) : "----"),
  },
  {
    title: "User",
    dataIndex: "user",
    width: 100,
    render: (text) => {
      if (!text) return <span>----</span>;
      const atIndex = text.indexOf("@");
      const displayText = atIndex !== -1 ? text.substring(0, atIndex + 1) : text;
      return (
        <Tooltip title={text}>
          <span>{displayText}</span>
        </Tooltip>
      );
    },
  },
  {
    title: "Exception",
    dataIndex: "exception",
    render: (text, rec) => (rec.isException ? loactionFun(rec) : "----"),
  },
  {
    title: "Remarks",
    render: (record) => {
      return record?.status === "SCHEDULED_FOR_TRIP" || record?.status === "HUB-OUTSCAN" || record?.status === "IN-BAG-OUTSCAN" ? (
        <span>
          {(record?.status === "SCHEDULED_FOR_TRIP" ? "Scheduled Outscan" : "Outscan") + ` from ${normalizeString(
            record?.premisename || record?.premiseName
          )} to ${normalizeString(record?.topremisename || record?.toPremisename)} `}
          {record?.lcrnum && (
            <>
              <span style={{ fontWeight: "bold" }}>
                LCR No.:
                <span
                  style={{ color: "#2977ff", cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => {
                    const recordToStore = {
                      vehicle_lcr_id: record.lcrnum,
                    };
                    sessionStorage.setItem("LCR_REPORT_RECORD", JSON.stringify(recordToStore));
                    window.open(window.location.origin + "/lcr-report", "_blank");
                  }}
                >
                  {record?.lcrnum || "N/A"}
                </span>
              </span>
            </>
          )}
          <span className="tooltipClass">
            <Tooltip
              className="tooltipClass"
              placement="bottom"
              title={
                <div className="tooltipClass">
                  <div className="item">
                    <span className="label">Co-loader:</span>{" "}
                    <span className="value">{record?.coloader || record?.coLoader || "N/A"}</span>
                  </div>
                  <div className="item">
                    <span className="label">Transport Type:</span>{" "}
                    <span className="value">{record?.travelby || record?.travelBy || "N/A"}</span>
                  </div>
                  <div className="item">
                    <span className="label">Flight Number:</span>{" "}
                    <span className="value">{record?.flightnum || record?.flightNum || "N/A"}</span>
                  </div>
                  <div className="item">
                    <span className="label">Vehicle No:</span>{" "}
                    <span className="value">{record?.vehiclenum || record?.vehicleNum || "N/A"}</span>
                  </div>
                  <div className="item">
                    <span className="label">Driver Name:</span>{" "}
                    <span className="value">{record?.drivername || record?.driverName || "N/A"}</span>
                  </div>
                </div>
              }
            >
              <InfoIcon />
            </Tooltip>
          </span>
        </span>
      ) : record?.remarks ? (
        <span>{record?.remarks}</span>
      ) : (
        <div>----</div>
      );
    },
  },
];

export const auditCol = [
  {
    title: "Awb No",
    dataIndex: "awbNo",
    key: "awbNo",

    render: (text, val) => {
      return (
        <div>
          <span>{text}</span>
          {val?.auditStatus && <Audit_icon />}
        </div>
      );
    },
  },
  {
    title: "Source Hub",
    dataIndex: "sourceHubName",
    key: "sourceHubName",

    render: (text) => {
      return text ? camelCase(text) : "-----";
    },
  },
  {
    title: "Destination Hub",
    dataIndex: "destinationHubName",
    key: "destinationHubName",
    sorter: (a, b) =>
      a?.destinationHubName?.localeCompare(b?.destinationHubName),

    render: (text) => {
      return text ? camelCase(text) : "-----";
    },
  },
  {
    title: "Audited Hub Details",
    dataIndex: "auditedHubName",
    key: "auditedHubName",
    render: (text, rec) => {
      return (
        <>
          <div>{text && camelCase(text)}</div>
          <div>{rec?.auditTime && rec?.auditTime}</div>
        </>
      );
    },
  },
  {
    title: "Booking types",
    dataIndex: "bookingType",
    key: "bookingType",

    render: (text) => {
      return text ? text : "-----";
    },
  },
  {
    title: "Service type",
    dataIndex: "serviceType",
    key: "serviceType",
    render: (text) => {
      return text ? text : "-----";
    },
  },

  {
    title: "Audited for",
    dataIndex: "auditType",
    key: "auditType",

    render: (text) => (text ? camelCase(text) : "-----"),
  },
  {
    title: "Booking Value",
    dataIndex: "auditType",
    key: "premiseName",

    render: (text, rec) => (
      <TableCompo
        actual={rec?.bookedWeight}
        l={rec?.bookedLength}
        b={rec?.bookedWidth}
        h={rec?.bookedHeight}
        volumetric={rec?.volumetricBookedValue}
      />
    ),
  },
  {
    title: "Audited Value",
    dataIndex: "auditType",
    key: "premiseName",
    render: (text, rec) => (
      <TableCompo
        actual={rec?.auditedWeight}
        l={rec?.auditedLength}
        b={rec?.auditedWidth}
        h={rec?.auditedHeight}
        volumetric={rec?.volumetricAuditedValue}
      />
    ),
  },
  {
    title: "Alert type",
    dataIndex: "volWeightDiffPerc",
    key: "volWeightDiffPerc",
    fixed: "right",

    render: (recored, rec) => {
      const shouldRenderSubstract =
        (rec?.weightDiff && rec?.weightDiff > 10) ||
        (rec?.volWeightDiff && rec?.volWeightDiff > 10);

      return shouldRenderSubstract ? <Aubstract /> : <Substract />;
    },
  },
];

const TableCompo = ({ l, b, h, volumetric, actual }) => {
  return (
    <Row justify={"space-between"} gutter={[10, 15]} style={{ width: "500" }}>
      <Col lg={16} style={{ fontWeight: "500" }}>
        Actual
      </Col>
      <Col lg={8}>{actual}</Col>
      <Col lg={16} style={{ fontWeight: "500" }}>
        Volumetric
      </Col>
      <Col lg={8}>{volumetric}</Col>
      <Col lg={16} style={{ fontWeight: "500" }}>
        LWH
      </Col>
      <Col lg={8}>{`${l},${b},${h}`}</Col>
    </Row>
  );
};
